import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Background, HugeRollingOffer } from '@appcharge/shared-ui';
import useOffersUI from 'api/useOffersUI';
import useTheme from 'api/useTheme';
import { RollingOfferProductSequence } from 'common/contracts';
import { ESaleDiscountDisplayType } from 'constants/enums';
import Decimal from 'decimal.js';
import { MockProps } from 'views/RollingOffers/types';

const mapProductsSequence = (
  productsSequence: RollingOfferProductSequence[]
) => {
  return productsSequence.map((item) => ({
    ...item,
    prices: {
      priceInUsdCents: new Decimal(item?.priceInUsdCents || 0)
        .mul(100)
        .toNumber(),
      priceDisplay: `$${item?.priceInUsdCents || 0}`,
      currencyCode: 'USD'
    },
    products: item?.products.map((productItem) => ({
      ...productItem,
      ...productItem?.product,
      images: {
        product:
          productItem?.product?.images?.find((img) => img.type === 'product')
            ?.url ||
          productItem?.product?.images?.[0]?.url ||
          null
      }
    })),
    salePercentage: item?.productSale?.sale || 0,
    salePercentageDisplayType: ESaleDiscountDisplayType.PERCENTAGE,
    badges: item?.badges || []
  }));
};

const RollingOfferMock: React.FC<MockProps> = ({
  currentOfferUI,
  productsSequence
}) => {
  const { publisherId } = useParams();
  const { getOfferUI } = useOffersUI(publisherId, currentOfferUI);
  const { getGeneralTheme: generalTheme, getStoreScreen: screenTheme } =
    useTheme(publisherId);

  useEffect(() => {
    if (currentOfferUI) getOfferUI.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOfferUI]);

  const isThemeLoading = generalTheme?.isLoading;
  const offerUIData = getOfferUI?.data;

  const subRollingOffersProducts = productsSequence
    ? mapProductsSequence(productsSequence)
    : [];

  return (
    <div className="iphone-mock-wrapper">
      <div className="iphone-mock w-[500px]" id="iphone-mock">
        <Background
          backgroundImageMobile={
            isThemeLoading ? null : generalTheme.data?.backgroundImageMobile
          }
          backgroundImageDesktop={
            isThemeLoading ? null : generalTheme.data?.backgroundImageDesktop
          }
          width="100%"
          height="100%"
          position="absolute"
        />
        <HugeRollingOffer
          isPreview={true}
          backgroundImage={offerUIData?.backgroundImage}
          headerImage={offerUIData?.rollingOffer?.headerImage}
          backgroundOpacity={offerUIData?.rollingOffer?.backgroundOpacity}
          backgroundColor={offerUIData?.rollingOffer?.backgroundColor}
          borderColor={offerUIData?.borderColor}
          borderWidth={offerUIData?.borderWidth}
          indexToCollect={1}
          collectBehavior="disappear"
          arrowColor={offerUIData?.rollingOffer?.arrowColor}
          arrowImage={offerUIData?.rollingOffer?.arrowImage}
          subRollingOffersProducts={subRollingOffersProducts}
          subRollingOfferUiProps={{
            backgroundColor:
              offerUIData?.rollingOffer?.subRollingOffer?.backgroundColor,
            backgroundImage:
              offerUIData?.rollingOffer?.subRollingOffer?.backgroundImage,
            lockImage: offerUIData?.rollingOffer?.subRollingOffer?.lockImage,
            buttonColor: screenTheme.data?.buttonColor,
            collectText:
              offerUIData?.rollingOffer?.subRollingOffer?.collectText,
            buttonTextColor: screenTheme.data?.buttonColor
          }}
          selectOffer={async () => true}
        />
      </div>
    </div>
  );
};

export default RollingOfferMock;
